<!-- eslint-disable vue/v-slot-style -->
<script>
// Seletor de etapa do Kanban (combobox) — migrado 1:1 do ConversationAction.vue
// para ficar no TOPO do painel lateral (posição do antigo box). Mesma lógica:
// funis = custom attributes de conversa tipo lista; troca a etapa via
// updateCustomAttributes com EXCLUSIVIDADE entre funis; agente comum não vê "Admin".
import { mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';
import { useAdmin } from 'dashboard/composables/useAdmin';
import ContactDetailsItem from './ContactDetailsItem.vue';
import MultiselectDropdown from 'shared/components/ui/MultiselectDropdown.vue';

export default {
  components: { ContactDetailsItem, MultiselectDropdown },
  setup() {
    const { isAdmin } = useAdmin();
    return { isAdmin };
  },
  computed: {
    ...mapGetters({
      currentChat: 'getSelectedChat',
      conversationAttributes: 'attributes/getConversationAttributes',
    }),
    funnels() {
      return (this.conversationAttributes || [])
        .filter(a => a.attributeDisplayType === 'list')
        .map(a => ({
          key: a.attributeKey,
          name: a.attributeDisplayName || a.attributeKey,
          stages: (a.attributeValues || []).filter(
            s => this.isAdmin || String(s).trim().toLowerCase() !== 'admin'
          ),
        }));
    },
  },
  methods: {
    stageOptions(funnel) {
      return funnel.stages.map(s => ({ id: s, name: s }));
    },
    selectedStage(funnel) {
      const cur = (this.currentChat.custom_attributes || {})[funnel.key];
      return cur ? { id: cur, name: cur } : null;
    },
    onSelectStage(funnel, item) {
      if (!item || !item.id) return;
      const cur = (this.currentChat.custom_attributes || {})[funnel.key];
      if (item.id === cur) return;
      const merged = { ...(this.currentChat.custom_attributes || {}) };
      merged[funnel.key] = item.id;
      // exclusividade: um ticket pertence a UM funil custom
      this.funnels.forEach(f => {
        if (f.key !== funnel.key) delete merged[f.key];
      });
      this.$store
        .dispatch('updateCustomAttributes', {
          conversationId: this.currentChat.id,
          customAttributes: merged,
        })
        .then(() => useAlert('Etapa atualizada'))
        .catch(() => {});
    },
  },
};
</script>

<template>
  <div v-if="funnels.length" class="px-2 pt-2">
    <div v-for="funnel in funnels" :key="funnel.key">
      <ContactDetailsItem compact :title="'Etapa · ' + funnel.name" />
      <MultiselectDropdown
        :options="stageOptions(funnel)"
        :selected-item="selectedStage(funnel)"
        multiselector-title="Etapa do Kanban"
        multiselector-placeholder="Selecionar etapa"
        no-search-result="Nenhuma etapa"
        input-placeholder="Buscar etapa"
        @select="item => onSelectStage(funnel, item)"
      />
    </div>
  </div>
</template>
